import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class AdminBoxSaleApproveStatusOrdersResponse {
  @jsonMember(Number)
  public readonly paid!: number;

  @jsonMember(Number)
  public readonly partiallyCompleted!: number;

  @jsonMember(Number)
  public readonly partiallyRefunded!: number;
}
